import { render, staticRenderFns } from "./HeaderNew.vue?vue&type=template&id=211f84ae&"
import script from "./HeaderNew.vue?vue&type=script&lang=js&"
export * from "./HeaderNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports